import React from 'react';

// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
//  AI-MELDING — verplichte transparantie bij AI-interactie
//
//  Artikel 50 lid 1 AI-verordening (EU) 2024/1689, van toepassing
//  vanaf 2 augustus 2026: wie een AI-systeem aanbiedt dat direct met
//  mensen communiceert, moet die mensen laten weten dat zij met een
//  AI-systeem te maken hebben, uiterlijk bij de eerste interactie.
//
//  De wet kent een uitzondering wanneer het "overduidelijk" is. Daar
//  vertrouwen we niet op: dat is een discussie achteraf, en deze regel
//  tekst kost niets.
//
//  De tweede zin staat er niet vanwege de wet maar vanwege de
//  werkvloer. Een monteur die op dit antwoord een machine bedient,
//  moet weten dat het uit documentatie is afgeleid en niet uit een
//  waarheid.
// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

const MELDING = 'Je praat met een AI-systeem.';
const VOORBEHOUD = 'Antwoorden komen uit je eigen documentatie en kunnen onvolledig of onjuist zijn. Controleer ze aan de bron voordat je aan een machine werkt.';

const AiMelding = ({ compact = false }) => {
    if (compact) {
        return (
            <p className="text-[10px] leading-relaxed text-slate-500 px-1">
                <span className="text-slate-400 font-bold">{MELDING}</span>{' '}
                {VOORBEHOUD}
            </p>
        );
    }

    return (
        <div className="flex items-start gap-3 bg-slate-800/40 border border-slate-700/50 rounded-xl px-4 py-3 mb-6">
            <span className="text-base leading-none mt-0.5" aria-hidden="true">ℹ️</span>
            <p className="text-xs leading-relaxed text-slate-400">
                <span className="text-slate-200 font-bold">{MELDING}</span>{' '}
                {VOORBEHOUD}
            </p>
        </div>
    );
};

export default AiMelding;
